import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/besondere-genehmigungen/')(
  {
    component: () => (
      <ChoiceTypeManagement
        choiceTypeKey="SpecialPermissions"
        returnRoute="/auswahlfelder/specialPermissions"
      />
    ),
    beforeLoad: choicesReadGuard,
  },
);

export const SpecialPermissionsRoute = Route;
